var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apparea"},[_vm._v(" Template Hotel Flight App ")])
}
var staticRenderFns = []

export { render, staticRenderFns }